import { Box, Flex, HStack, Text, type BoxProps } from '@chakra-ui/react'
import { type ReactNode } from 'react'

interface Props extends Omit<BoxProps, 'children' | 'title'> {
  children: ReactNode
  eyebrow?: ReactNode
  title?: ReactNode
  description?: ReactNode
  showBrand?: boolean
}

export default function InternalStandaloneLayout({
  children,
  eyebrow,
  title,
  description,
  showBrand = true,
  ...cardProps
}: Props) {
  return (
    <Flex
      minH="100vh"
      bg="gray.50"
      align="center"
      justify="center"
      px={4}
      py={{ base: 8, md: 12 }}
    >
      <Box w="full" maxW="440px">
        {showBrand && (
          <HStack justify="center" mb={6} spacing={2}>
            <Flex
              w="30px"
              h="30px"
              borderRadius="8px"
              bg="gray.900"
              color="white"
              align="center"
              justify="center"
              fontWeight="800"
            >
              S
            </Flex>
            <Text fontSize="md" fontWeight="700" letterSpacing="-0.025em">
              Sijilo
            </Text>
          </HStack>
        )}
        <Box
          bg="white"
          border="1px solid"
          borderColor="gray.200"
          borderRadius="12px"
          boxShadow="sm"
          p={{ base: 6, md: 8 }}
          {...cardProps}
        >
          {eyebrow && (
            <Text
              textAlign="center"
              color="gray.500"
              fontSize="xs"
              fontWeight="600"
              mb={2}
            >
              {eyebrow}
            </Text>
          )}
          {title && (
            <Text
              as="h1"
              textAlign="center"
              fontSize="xl"
              fontWeight="700"
              letterSpacing="-0.025em"
            >
              {title}
            </Text>
          )}
          {description && (
            <Text
              textAlign="center"
              color="gray.500"
              fontSize="sm"
              mt={2}
              mb={6}
            >
              {description}
            </Text>
          )}
          {children}
        </Box>
      </Box>
    </Flex>
  )
}
